import React, { Component } from 'react';
import './sensorDeviceControl.less';
import PubSub from 'pubsub-js'
import { meshLog, SPRemove, SPGet, SPSet } from "../../../../../../utils/spUtils";
import { getDevicesByGroupId, getNameBygroupID, getBleVer } from '../../../../../../utils/meshUtils';
import { sendOpcode_device_light, sendOpcode_device_ota, sendOpcode_device_onOff } from '../../../../../../utils/opcodeUtils';
import light_normal3 from "../../../../../../imgs/mesh/light_normal3.png";
import btn_on from "../../../../../../imgs/mesh/btn_on.png";
import sensorDeviceControllogo from "../../../../../../imgs/logo/sensorDeviceControllogo.png";
import btn_off from "../../../../../../imgs/mesh/btn_off.png";
import montion from "../../../../../../imgs/item/montion.png";
import arrow_right from "../../../../../../imgs/btn/arrow_right.png";
import ota from "../../../../../../imgs/btn/ota.png";
import { getDeviceNameByPid } from '../../../../../../utils/pidUtils';

import { saveDeviceInfor } from '../../../../../../utils/homeUtils';



export default class SensorDeviceControl extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOn: true,
            dimLevel: 50,
            groupInfo: '',
            checked: false, //group是否展开
            devices: [], //group数据
            deviceName: "HSE",
            areaGroupDesc: "",
            devicePid: "pid",
            deviceMac: "mac",
            deviceVid: "vid",
            manufacture: "20409-09",
        }
    }



    componentDidMount() {
        this.updateGroupUI();
        PubSub.subscribe('updateGroupdataUI', (msg, data) => {
            this.updateGroupUI();
        })

        PubSub.subscribe("SET_ControlPageDetailPage_DIALOG_HIDE", (msg, index) => {
            meshLog("SET_ControlPageDetailPage_DIALOG_HIDE:", index);
            this.sendDataToParent()
        });
        this.sendDataToParent()
        //更新vid
        PubSub.subscribe("otaupdate", (msg, data) => {
            meshLog("更新vid", data);
            this.setState({
                deviceVid: getBleVer(data),
            });
        });


    }

    updateGroupUI() {
        meshLog('group渲染第一步', this.props);
        const groupInfo = JSON.parse(SPGet("groupInfo"))
        this.setState({
            groupInfo: groupInfo,
            dimLevel: groupInfo.dimLevel,
            isOn: groupInfo.isOnOff,
            // groupDevices: groupDevices,
            devices: getDevicesByGroupId(groupInfo.groupID), //group数据
        })
    }


    //原本的处理方法
    handleChange = (key, value) => {
        //边输入边赋值
        meshLog('value', value);
        meshLog('key', key);
        this.setState({ [key]: value });
        if (key == 'isOn') {
            const isOn = this.state.isOn
            this.setState({
                isOn: !isOn
            });
            sendOpcode_device_onOff(!isOn);
        } else {
            // sendOpcode_group_light(key, value);
            this.setState({ [key]: value });
        }

    };

    handleChange1 = (key, value) => {
        //边输入边赋值
        meshLog('value', value);
        meshLog('key', key);
        this.setState({ [key]: value });
    };

    handleMouseUp = (key, value) => {
        //边输入边赋值 鼠标离开发指令，主要是针对调光调色
        meshLog('handleMouseUphandleMouseUp', value);
        sendOpcode_device_light(key, value);
    };

    sendDataToParent() {
        const controlDevice = JSON.parse(SPGet("controlDevice"))
        meshLog("controlDevice", controlDevice);
        if (controlDevice) {
            this.setState({
                deviceName: controlDevice.name,
                areaGroupDesc: SPGet("SelectMeshName") + ", " + getNameBygroupID(controlDevice.groupID),
                devicePid: getDeviceNameByPid(controlDevice.pid),
                deviceMac: controlDevice.macAddress,
                deviceVid: getBleVer(controlDevice.vid),
            });
        }

    };

    //ota
    otaClick = () => {
        sendOpcode_device_ota();


        // const firmware_version = JSON.parse(SPGet("firmware_version"))
        // const newv = parseInt(firmware_version.substring(firmware_version.length - 6))
        // const device_detail = JSON.parse(SPGet("controlDevice"))
        // const newv2 = Math.floor(newv / 10000) * 2048 + newv % 10000 / 100 * 64 + newv % 100;
        // device_detail.vid = newv2
        // meshLog('groupInfo', device_detail);
        // meshLog('newv2newv2', newv2);
        // const nodes = saveDeviceInfor(device_detail)
        // meshLog('nodes', nodes);
        // this.setState({
        //     deviceVid: getBleVer(newv2),
        // });

    };

    gotoSensorDevice = () => {
        PubSub.publish('gotoSensorDevice', '')//显示Sensror界面
    }


    render() {
        const { isOn, dimLevel, deviceName, areaGroupDesc, devicePid, deviceMac, deviceVid, manufacture } = this.state;

        return (
            <div className="sensorDeviceControl-container">
                <div className="sensorDeviceControl-ui_grey_bg" />
                <div className="sensorDeviceControl-popup">
                    <div style={{ marginTop: "20px" }}>
                        <span style={{ marginLeft: "20px", fontSize: "18px" }}>Single Device Control</span>
                        {/* 灯数据 */}
                    </div>
                    <div className="sensorDeviceControl-line_space"></div>
                    {/* 组名和电源按钮 */}
                    <div className="sensorDeviceControl-group-header">
                        <div className="sensorDeviceControl-action-title">
                            <img src={montion} />
                            <span>{deviceName}</span>
                        </div>

                    </div>
                    {/* Dim Level */}
                    <div className="sensorDeviceControl-dim-level">
                        <div className="label">Dim level</div>
                        <div className="value-boxes">
                            <div className="box">{dimLevel}%</div>
                        </div>

                    </div>
                    {/* Dim滑动条 */}
                    <div style={{ textAlign: "center", height: 60, display: 'flex' }}>
                        <input type="range"
                            min="0"
                            max="100"
                            value={dimLevel}
                            className="sensorDeviceControl-slider"
                            onMouseUp={(e) => this.handleMouseUp('dimLevel', parseInt(e.target.value))}
                            onChange={(e) => this.handleChange1('dimLevel', parseInt(e.target.value))} />
                        <img className="sensorDeviceControl-onoff-icon" src={isOn ? btn_on : btn_off} onClick={(e) => this.handleChange('isOn', parseInt(e.target.value))} />
                    </div>


                    {/* 标题行 */}
                    <div className="sensorDeviceControl-controlPage_row">
                        <div className="sensorDeviceControl-controlPage_title">
                            <img className='sensorDeviceControl-icon' src={sensorDeviceControllogo} />
                            <span className='sensorDeviceControl-span'>Information</span>
                        </div>
                        {/* <span className='sensorDeviceControl-title_desc'>{areaGroupDesc}</span> */}
                    </div>


                    <div className="sensorDeviceControl-data-row">
                        <span className='item'>Device Type</span>
                        <span className='tips'>{devicePid}</span>
                    </div>
                    <div className="sensorDeviceControl-data-row">
                        <span className='item'>MAC Address</span>
                        <span className='tips'>{deviceMac}</span>
                    </div>
                    <div className="sensorDeviceControl-data-row">
                        <span className='item'>Firmware Version</span>
                        <span className='tips'>{deviceVid}</span>
                    </div>
                    <div className='sensorDeviceControl-ota'>
                        <div className="ota-info">
                            <span className='item'>OTA</span>
                            <img className='icon' onClick={() => { this.otaClick() }} src={ota} />
                        </div>
                        {/* <div className="ota-info">
                        <span>Date of Manufacture</span>
                        <span>202409-09</span>
                    </div> */}
                    </div>
                    <div className="sensorDeviceControl-data-row">
                        <span className='item'>Date of Manufacture</span>
                        <span className='tips'>{manufacture}</span>
                    </div>


                    <div className="sensorDeviceControl-info-row">
                        <div className="info-title">
                            <span className="info-span" >Occupancy Events</span>
                        </div>
                        <img className='arrow' src={arrow_right} />
                    </div>
                    {/* <div className="data-row2">
                    <span className='item2'>Date of Manufacture</span>
                    <span className='item2'>Date of Manufacture</span>
                    <span className='item2'>Date of Manufacture</span>
                </div> */}

                    <div className="sensorDeviceControl-info-row">
                        <div className="info-title">
                            <span className="info-span" >Operation Logs</span>
                        </div>
                        <img className='arrow' src={arrow_right} />
                    </div>
                    {/* <div className="data-row2">
                    <span className='item2'>Date of Manufacture</span>
                    <span className='item2'>Date of Manufacture</span>
                    <span className='item2'>Date of Manufacture</span>
                </div> */}




                    {/* 底部按钮 */}
                    <div className="control-footer">
                        <button className='cancelBtn' onClick={() => this.gotoSensorDevice()}>Cancel</button>
                        <button className='okBtn' onClick={() => this.gotoSensorDevice()} >Confirm</button>
                    </div>

                </div>

            </div>
        );
    }
}
